module.exports = __webpack_public_path__ + "static/media/img20.13029e13.jpg";